import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import footer from "../../assets/media/images/footer.png";
import{
	MDBRow,
	MDBCol,
	MDBCard,
	MDBNav,
	MDBNavItem,
	MDBNavLink,
	MDBContainer,
} from 'mdbreact';

class Footer extends Component {

  constructor(props) {
    super(props);
  };

  render() {
    return (
			<div className="footer-div">
      <MDBContainer style={{maxWidth: "1430px"}}>
      <MDBRow className="pt-2 pb-2 m-0">
        <MDBCol middle md="2" lg="2" className="text-left">
          {/*<Link to="/Impresszum">
            <span className="impresszum">Impresszum</span>
          </Link>*/}
        </MDBCol>
        <MDBCol middle md="8" lg="8" className="text-center">
        <img className="footer-img" src={footer}></img>
        </MDBCol>
        <MDBCol middle md="2" lg="2" className="text-right">
          <Link to="/AdatkezelesiTajekoztato">
            <span className="adatkezelesi-nyilatk">Adatkezelési tájékoztató</span>
          </Link>
        </MDBCol>
      </MDBRow>
      </MDBContainer>
      </div>


    );
  }
}

export default Footer;
